export class Calculated {
    /* This decorator must be used wisely. The output of the decorated function 
    can only derive from the immutable mentioned in the decorator*/
    public static fromImmutable(fetchImmutable: (me: any) => object) {
        const myWeakMap = new WeakMap();
        const myEmptyKey = {};

        return function (_target: any, _name: string, property: any) {
            if (property.value) {
                const fn = property.value;
                property.value = function (...args: any[]) {
                    const currentObject = fetchImmutable(this) || myEmptyKey;
                    if (!myWeakMap.get(currentObject)) {
                        myWeakMap.set(currentObject, fn.apply(this, args));
                    }
                    return myWeakMap.get(currentObject);
                };
            } else if (property.get) {
                const fn = property.get;
                property.get = function (...args: any[]) {
                    const currentObject = fetchImmutable(this) || myEmptyKey;
                    if (!myWeakMap.get(currentObject)) {
                        myWeakMap.set(currentObject, fn.apply(this, args));
                    }
                    return myWeakMap.get(currentObject);
                };
            }
        };
    }
    public static fromParameter(fetchParam: (args: any) => any) {
        const myWeakMap = new WeakMap();
        const myEmptyKey = {};

        return function (_target: any, _name: string, property: any) {
            if (property.value) {
                const fn = property.value;
                property.value = function (...args: any[]) {
                    const currentObject = fetchParam.apply(args) || myEmptyKey;
                    if (!myWeakMap.get(currentObject)) {
                        myWeakMap.set(currentObject, fn.apply(this, args));
                    }
                    return myWeakMap.get(currentObject);
                };
            } else if (property.get) {
                const fn = property.get;
                property.get = function (...args: any[]) {
                    const currentObject = fetchParam(args) || myEmptyKey;
                    if (!myWeakMap.get(currentObject)) {
                        myWeakMap.set(currentObject, fn.apply(this, args));
                    }
                    return myWeakMap.get(currentObject);
                };
            }
        };
    }
}
